<template>
  <PageTemplate>

    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          {{ $t('audit.title') }}
        </h6>
      </div>

      <div class="element-box">
        <div class="d-flex justify-content-between">
          <h6 class="element-header">
            {{ $t('office.information') }}
          </h6>

          <CreateButton
              :label="$t('general.button.back')"
              :to="{ name: 'auditOfficeList' }">
          </CreateButton>
        </div>

        <h5 class="border-bottom"><span class="me-2">Bezeichnung:</span> {{ office.name }}</h5>
        <h6 class="mb-5 mt-3"><span class="me-2">Extern/Intern:</span> {{ office.engagementTypeTranslation }}</h6>

        <h5 class="form-header mb-2 mt-5">
          {{ $t('audit.list') }}
        </h5>
        <div class="element-actions text-end mb-3">
          <div v-if="canAddNewAudit">
            <router-link class="btn btn-primary"
                    :to="{name: 'auditFormCreate', params: {officeId: office.id} }">
              {{ $t('audit.new') }}
            </router-link>
          </div>
          <div v-else>
            <p class="text-danger">
              Bitte klären Sie geplante Audits, bevor Sie ein neues erstellen
            </p>
          </div>
        </div>

        <EmptyState
            v-if="!audits.data?.length"
            icon="fa-clipboard-check"
            title="Keine Audits gefunden"/>

        <div v-else class="table-responsive mt-3">
          <table class="table table-striped">
            <thead>
            <tr>
              <th style="min-width: 190px !important">Audit Datum</th>
              <th style="min-width: 190px !important">Status</th>
              <th style="width: 70%">Auditor</th>
              <th style="min-width: 130px !important;  text-align: center">Aktionen</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="audit in audits.data" :key="audit.id">
              <td>
                <strong>{{ audit.date }}</strong>
              </td>
              <td>
                <strong>{{ audit.statusTranslation }}</strong>
              </td>
              <td>
                <strong>{{ audit.auditor }}</strong>
              </td>
              <td class="text-end">
                <div v-if="audit.status === 'planed'">
                  <button class="btn btn-primary"
                          @click="router.push({
                          name: 'auditFormUpdate',
                          params: {officeId: office.id, id: audit?.id}
                          })">
                    <i class="os-icon os-icon-edit"></i>
                  </button>
                  <button class="btn btn-danger ms-2"
                          @click="deleteModal(audit?.id)">
                    <i class="os-icon os-icon-trash"></i>
                  </button>
                </div>
                <div v-else>
                  <button class="btn btn-primary"
                          @click="router.push({
                          name: 'auditFormUpdate',
                          params: {officeId: office.id, id: audit?.id}
                          })">
                    <i class="os-icon os-icon-edit"></i>
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import officeAuditService from '@/api/OfficeAudit';
import CreateButton from '@/components/CreateButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import router from '@/router';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const isLoaded       = ref(false);
const route          = useRoute();
const officeId       = route.params.officeId;
const office         = ref({});
const audits         = ref([]);
const canAddNewAudit = ref(true);

async function getAuditList() {
  CloseToast();
  try {
    const { data } = await officeAuditService.getOfficeAuditList(+officeId);

    office.value         = data.data.office;
    audits.value         = data.data.audits;
    canAddNewAudit.value = data.data.canAddNewAudit;
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await getAuditList();
  isLoaded.value = true;
});

</script>

<style scoped>
</style>